import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import useIsSuperUser from '../hooks/useIsSuperUser';

/**
 * Strict Django `is_superuser` route guard (SuperAdminGuard is looser: it
 * lets through any user while the list is empty). Fails closed: an empty or
 * failed practice-user list redirects rather than rendering the children.
 */
export default function SuperUserGuard({ children }) {
    const { isSuperUser, isResolved } = useIsSuperUser();
    if (!isResolved) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
                <CircularProgress />
            </Box>
        );
    }
    if (!isSuperUser) return <Navigate to="/dashboard/permission-denied" replace />;
    return <>{children}</>;
}

SuperUserGuard.propTypes = { children: PropTypes.node };
